import React, { useEffect } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import line_vector from "../assets/line3-vector.svg";
import arrow_new from "../assets/Arrow_service.svg";
import initializeAOS from "../utils/aosLibrary";
import { useMediaQuery } from "@mui/material";

function PageNotFound() {
  const isXs = useMediaQuery("(min-width:600px) and (max-width:3000px)");

  useEffect(() => {
    document.title = "404 Page Not Found";

    initializeAOS();
  }, []);

  const fontLivic = "Livvic , sans-serif";
  return (
    <>
      <Navbar />
      <div
        style={{
          height: "300px",
          background:
            "linear-gradient(105deg, rgba(244, 236, 194, .6) 1.74%, rgba(228, 250, 242, .6) 39.85%, rgba(211, 243, 207, .6) 73.94%, rgba(255, 243, 228, .6) 98.01%)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <h1
            data-aos="fade-up"
            style={{
              fontSize: isXs ?"64px":"50px",
              lineHeight: "1.15",
              letterSpacing: "0.67px",
              fontWeight: "bold",
              fontWeight: "700",
            }}
          >
            404 Page Not Found
          </h1>
        </div>
        <img
          src={arrow_new}
          loading="lazy"
          alt="Hero Shape Image"
          className="hero-shape-2"
          style={{
            display: isXs ? "flex" : "none",
            animation: "moveUpDown 1.5s infinite alternate",
            position: "absolute",
            top: "180px",
            left: "87px",
            zIndex: "5",
          }}
        />
        <img
          style={{
            display: isXs ? "flex" : "none",
            position: "absolute",
            right: "0",
            top: "200px",
          }}
          src={line_vector}
          alt=""
        />
      </div>
      <div
        style={{
          textAlign: "center",
          height: "100px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <button
          style={{
            color: "white",
            backgroundColor: "#6128d3",
            border: "none",
            borderRadius: "22px",
            padding: "10px 20px",
            fontFamily: fontLivic,
          }}
        >
          {" "}
          <a style={{ textDecoration: "none", color: "white" }} href="/">
            Go Back to Home Page
          </a>{" "}
        </button>
      </div>
      <Footer />
    </>
  );
}

export default PageNotFound;
